var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nprogress-container'),_c(_vm.$route.meta.layout || 'div',{tag:"component"}),_c('notifications',{staticClass:"g-notification",attrs:{"position":"top center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }